import { useIntl, type WalletCustody } from '@capsicum/common';
import {
	useMyCollectibles,
	useMyOngoingParticipationsCollectibles
} from '@capsicum/features/digital-collectibles/shared';

export const useWalletCollectiblesLists = (walletCustody: WalletCustody) => {
	const { $t } = useIntl();

	const {
		data: { collectibles, favoriteCollectibles } = { collectibles: [], favoriteCollectibles: [] },
		error: collectiblesErrors,
		isLoading: isLoadingCollectibles
	} = useMyCollectibles(walletCustody);
	const {
		data: { favorite: favoriteParticipationCollectibles, other: otherParticiapationCollectibles } = {
			favorite: [],
			other: []
		},
		error: ongoingParticipationErrors,
		isLoading: isLoadingParticipations
	} = useMyOngoingParticipationsCollectibles();

	const texts = {
		emptyList: $t('wallet.digitalCollectibles.emptyList'),
		favouriteTeamsTitle: $t('wallet.digitalCollectibles.favouriteTeamTitle'),
		goatAlt: $t('wallet.digitalCollectibles.goatAlt'),
		other: $t('global.other'),
		otherTeamsTitle: $t('wallet.digitalCollectibles.otherTeamsTitle'),
		title: $t('wallet.digitalCollectibles.pageTitle')
	};

	return {
		errors: [collectiblesErrors, ongoingParticipationErrors],
		favoriteCollectibles: [...favoriteParticipationCollectibles, ...favoriteCollectibles],
		isLoading: isLoadingCollectibles || isLoadingParticipations,
		otherCollectibles: [...otherParticiapationCollectibles, ...collectibles],
		texts
	};
};
